var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('f7-navbar',[_c('f7-nav-left',[_c('f7-link',{attrs:{"icon-if-ios":"f7:menu","icon-if-md":"material:menu","panel-open":"left"}})],1),_c('f7-nav-title',[_vm._v("管理系統")])],1),_c('f7-list',[_c('f7-list-item',{attrs:{"link":"manage-all-items","title":"管理所有品項","link-view":"#main-view","link-close-panel":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }